<template>
  <div class="w-full flex items-center border-app-primary-grey--concrete border-t border-b py-4">
    <AtomIconAppCircledExclamationMark :class="{ invisible: hideExclamationMark }" class="text-app-secondary-9-green--sherpa-blue w-6 h-6 inline mr-4 shrink-0" />
    <h3 class="text-sm md:text-base" :class="textColor"><slot /></h3>
  </div>
</template>

<script setup lang="ts">
defineProps({
  hideExclamationMark: { type: Boolean, required: false, default: false },
  textColor: { type: String, required: false, default: 'text-black' },
})
</script>

<style scoped lang="scss"></style>
